module.exports = __webpack_public_path__ + "img/logo-dark.be1de1c6.svg";